import { Controller } from "@hotwired/stimulus"
import Sortable from 'sortablejs'

export default class extends Controller {
  static targets = ["item"]

  connect() {
    this.sortable = new Sortable(this.element, {
      handle: '.cursor-move',
      animation: 150,
      onEnd: this.onEnd.bind(this)
    })
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  }

  async onEnd(event) {
    const items = Array.from(this.itemTargets)
    const newOrder = items.map(item => item.dataset.figureUserImageId)
    const collectionSlug = this.element.closest('[data-controller="collection-photos"]').dataset.collectionSlug
    
    try {
      const response = await fetch(`/my-collections/${collectionSlug}/reorder_images`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({ order: newOrder })
      })

      if (!response.ok) {
        throw new Error('Failed to update order')
      }
    } catch (error) {
      console.error('Error updating image order:', error)
      // Optionally show an error message to the user
    }
  }
} 